import { useFormikContext } from "formik";

import { IAddIncomeForm } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

const SalarySection89APreYearForm = () => {
  const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext<IAddIncomeForm>();

  return (
    <section>
      <FormField
        label="I(f). Income taxable during the pervious year on which relief u/s 89A was claimed in any earlier previous year"
        sm={6}
      >
        <NumericInputField
          showLeftIcon={true}
          name="IncomeTaxableDuringThePreviousYear89A"
          value={values.IncomeTaxableDuringThePreviousYear89A}
          onBlur={handleBlur("IncomeTaxableDuringThePreviousYear89A")}
          onChange={(value) => setFieldValue("IncomeTaxableDuringThePreviousYear89A", value)}
          isInvalid={
            Boolean(errors.IncomeTaxableDuringThePreviousYear89A) &&
            touched.IncomeTaxableDuringThePreviousYear89A
          }
          errorMsg={errors.IncomeTaxableDuringThePreviousYear89A}
        />
      </FormField>
    </section>
  );
};

export default SalarySection89APreYearForm;
